export default {
    // récuperer toutes les approvisionnements dans la base de données 
    get_all_approvisionnements(serverParams){
        return axios.post('/approvisionnement/list?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_approvisionnements_by_users(serverParams){
        return axios.post('/approvisionnement/user/' + serverParams.user_id+'?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_approvisionnements_own(serverParams){
        return axios.get('/mesapprovisionnement?page=' + serverParams.page, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les approvisionnements des entités dans la base de données 
    get_all_approvisionnemententite(){
        return axios.get('/approvisionnement/entite', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les approvisionnements des entités dans la base de données 
    get_all_approvisionnemententite_by_entity(serverParams){
        return axios.post('/approvisionnement/entite/' + serverParams.entite_id + '?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },

    // récuperer toutes les approvisionnements par agences dans la base de données 
    get_all_approvisionnementByAgence(serverParams){
        return axios.post('/approvisionnement/agence/' + serverParams.agence_id + '?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les approvisionnements des entités dans la base de données 
    get_all_approvisionnemententite_by_atm(serverParams){
        return axios.post('/approvisionnement/guichet/' + serverParams.guichet_id + '?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },

    // récuperer toutes les approvisionnements des guichets dans la base de données 
    get_all_approvisionnementguichet(){
        return axios.get('/approvisionnement/guichet', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },

    // récuperer toutes les approvisionnements dans la base de données 
    post_approvisionnementEntite(approvisionnement){
        return axios.post('/approvisionnement/entite',approvisionnement, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

    // récuperer toutes les approvisionnements dans la base de données 
    post_approvisionnementGuichet(approvisionnement){
        return axios.post('/approvisionnement/guichet',approvisionnement, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_approvisionnements(id,approvisionnement){
        return axios.put('/approvisionnements/'+id,approvisionnement, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // afficher l'entité dont le parametre est = id
    show_approvisionnements(id){
        return axios.get('/approvisionnements/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // supprimer l'entité dont le parametre est = id
    delete_approvisionnements(id){
        return axios.delete('/approvisionnements/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}